import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MapPin, Phone, Globe } from "lucide-react";

export default function ClinicLocatorMini() {
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        api.get("/clinics")
            .then((r) => { if (mounted) setClinics(r.data.slice(0, 6)); })
            .catch(() => {})
            .finally(() => mounted && setLoading(false));
        return () => { mounted = false; };
    }, []);

    if (loading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-champagne/20">
                {Array.from({ length: 6 }).map((_, i) => (
                    <div key={i} className="bg-ink/95 p-8 h-48 animate-pulse" />
                ))}
            </div>
        );
    }

    return (
        <div data-testid="clinic-mini-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-champagne/20">
            {clinics.map((c, i) => (
                <div key={c.id} data-testid={`mini-clinic-${i}`} className="bg-ink p-8 space-y-4">
                    <div className="eyebrow text-champagne">Certified · {c.city || "New Zealand"}</div>
                    <h3 className="font-serif text-2xl text-bone leading-tight">{c.name}</h3>
                    <p className="text-sm text-bone/60 leading-relaxed line-clamp-2">{c.address}</p>
                    <div className="flex flex-col gap-2 pt-2 text-xs text-bone/70">
                        {c.phone && <a href={`tel:${c.phone.replace(/\s+/g, "")}`} className="flex items-center gap-2 hover:text-champagne"><Phone size={12} strokeWidth={1.2}/> {c.phone}</a>}
                        {c.website && <a href={c.website} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-champagne"><Globe size={12} strokeWidth={1.2}/> Visit website</a>}
                    </div>
                    <Link to="/clinics" className="inline-flex items-center gap-1 text-[0.65rem] uppercase tracking-[0.2em] text-champagne hover:text-bone mt-2">
                        <MapPin size={12} strokeWidth={1.2}/> View on locator
                    </Link>
                </div>
            ))}
        </div>
    );
}
